var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    d: "M15.153.5H1.515A1.181 1.181 0 0 0 .334 1.681V15.32A1.181 1.181 0 0 0 1.515 16.5h13.638a1.181 1.181 0 0 0 1.181-1.181V1.68A1.181 1.181 0 0 0 15.153.5ZM5.103 14.13H2.697V6.489h2.406v7.641Zm-1.205-8.7a1.381 1.381 0 1 1 1.39-1.38 1.361 1.361 0 0 1-1.39 1.38Zm10.072 8.707h-2.405V9.962c0-1.23-.523-1.61-1.199-1.61-.713 0-1.413.537-1.413 1.641v4.144H6.547V6.494h2.314v1.06h.03c.233-.47 1.046-1.274 2.287-1.274 1.343 0 2.793.797 2.793 3.13l-.002 4.727Z"
  })));
};
export default SvgLinkedin;